import { getConfig } from '@leagueplatform/config';

export const getContentUrlConfigValue = () =>
  getConfig().config.core.contentUrl;

export const getContentUrl = (contentId: string) => {
  const contentPath = `content/${contentId}`;
  return contentId ? `${getContentUrlConfigValue()}/${contentPath}` : '';
};
